import { get } from 'lodash';
import { getRedirectParamsByMetric } from 'common/constants/metrics';
import QueryString from 'query-string';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { mapActivityTypeToEntityKey } from 'views/root/views/home/views/performance/views/MetricsInspection/Charts/ScatterChart/useFetchData/entities.utils';

export const useViewInActivity = () => {
  const onClickViewInActivity = ({
    widget,
    metricName,
    lastPeriod,
    filters,
    selectedPoints
  }) => {
    const {
      team,
      repo = [],
      contributor,
      service = [],
      label,
      activityType
    } = filters;

    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.METRICS_INSPECTION,
      click_type: TRACKING.CLICK.VIEW_IN_ACTIVITY,
      widget_name: widget?.name
    });

    const customPoint = { category: lastPeriod };
    const getRedirectParams = getRedirectParamsByMetric(
      true,
      true
    )({ metricName });
    const redirectParams = getRedirectParams(customPoint);
    const qsParams = {
      drilldown: true,
      used_in_metrics_calculation: true,
      ...redirectParams.qs,
      ...(team?.id ? { teams: team.id, context: 'team' } : { context: 'org' }),
      ...(contributor?.id && { contributors: contributor.id }),
      ...(repo.length && { repositories: repo.map(({ id }) => id).join(',') }),
      ...(service.length && {
        services: service.map(({ id }) => id).join(',')
      }),
      ...(label && { labels: label }),
      ...(selectedPoints?.length && {
        selected_ids: selectedPoints
          .map(
            point =>
              point?.extraData?.[mapActivityTypeToEntityKey[activityType]]
          )
          .filter(Boolean)
          .join(',')
      }),
      ...get(redirectParams, 'state', {})
    };
    window.open(
      `${redirectParams.path}?${QueryString.stringify(qsParams)}`,
      '_blank'
    );
  };

  return { onClickViewInActivity };
};
